import { useEvent } from '@bizzabo/entities';
export const eventTypes = {
    SSE: 'SSE',
};

export const useIsAgendaEnabledInEvent = eventUniqueName => {
    const isSSE = useIsSingleSessionEvent(eventUniqueName);
    return !isSSE;
};

export const useIsSingleSessionEvent = eventUniqueName => {
    const { data: event } = useEvent(eventUniqueName);
    // support production, we don't have event type in production
    if (event && event?.type === undefined) {
        return false;
    }
    return event && event?.type && event.type === eventTypes.SSE;
};
